import { render, staticRenderFns } from "./customercontribution.vue?vue&type=template&id=c9797822&scoped=true"
import script from "./customercontribution.vue?vue&type=script&lang=js"
export * from "./customercontribution.vue?vue&type=script&lang=js"
import style0 from "./customercontribution.vue?vue&type=style&index=0&id=c9797822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9797822",
  null
  
)

export default component.exports